/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-28 19:39:09
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-02-11 19:12:25
 * @FilePath: \baishu_react_ui\src\components\BsyDialog\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { createRef } from "react";
import ReactDOM from "react-dom";

import Dlg from "./dlg";
import { BsyUtils } from "../../utils/Utils";

const BsyMaskLayer = (props) =>
  new Promise((resolve, reject) => {
    // 此处参数需用圆括号，否则 eslint 报错
    let elementRef = createRef();
    let holder;
    let rootTokenClass = "rootTokenCls" + new Date().getTime();
    holder = document.createElement("div");
    holder.style.zIndex = window.FX.STATIC.zIndex++;
    // holder.classList.add("bsy-x-window-mask");
    holder.classList.add("BsyMaskLayer");
    if (typeof props.onMaskClick === "function") {
      holder.addEventListener("click", props.onMaskClick, false);
    }

    if (props.customCls) holder.classList.add(props.customCls);
    else {
      // holder.classList.add("scrollable");
      setTimeout(() => {
        holder.classList.add("fadein");
      }, 30);
    }
    let initLayer = document.querySelector(".BsyMaskLayer");
    if (initLayer) {
      initLayer.classList.remove("hasBackground");
      // hasBackground
      holder.classList.add("hasBackground");
    }
    holder.classList.add("rootTokenClass");

    document.body.appendChild(holder);

    let CleanRootNode = (e) => {
      // 当界面被点击时自动清理元素
      // e 为null，组件自己清理自己
      // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
      if (!e || !BsyUtils.closestClass(e.target, rootTokenClass)) {
        holder.classList.remove("fadein");
        setTimeout(() => {
          ReactDOM.unmountComponentAtNode(holder);
          if (typeof props.onMaskClick === "function") {
            holder.removeEventListener("click", props.onMaskClick, false);
          }
          holder.remove();
          document.removeEventListener("mouseup", CleanRootNode, false);

          let initLayer = document.querySelector(".BsyMaskLayer");
          if (initLayer) {
            initLayer.classList.remove("hasBackground");
          }
        }, 218);
      }
    };
    // document.addEventListener('mouseup', CleanRootNode, false);

    const newProps = { ...props };
    newProps.onRemoveRoot = () => {
      //自动清理
      CleanRootNode();
    };
    ReactDOM.render(
      <Dlg
        ref={(res) => {
          elementRef = res;
          resolve(res);
        }}
        {...newProps}
      />,
      holder
    );
  }).catch((res) => {
    console.error("BsyMaskLayer", res);
  });

export default BsyMaskLayer;
